export default "__VITE_ASSET__a3b9a12d__"